<div class="dialog-container">
  <app-dialog-header-with-help [title]="'toistuvat.dialog.otsikko' | translate | async" helpUrl="https://app.tettra.co/teams/lemontree/pages/toistuvat-laskut-lemonaidissa"> </app-dialog-header-with-help>

  <mat-dialog-content>
    @if (lomake) {
      <form>
        <mat-form-field>
          <mat-label>{{ 'toistuvat.dialog.ensimmainen-lahetyspvm' | translate | async }}</mat-label>
          <input matInput [matDatepicker]="picker" [formField]="lomake.ensimmainenLahetyspvm" [min]="minDate" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error>{{ 'toistuvat.dialog.virhe.virheellinen-pvm' | translate | async }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'toistuvat.dialog.toista' | translate | async }}</mat-label>
          <mat-select [formField]="lomake.toistoTyyppi">
            @for (valinta of toistoValinnat; track valinta) {
              <mat-option [value]="valinta.arvo">
                {{ valinta.nimi }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (naytaKuukaudenValinta) {
          <div>
            <mat-radio-group [formField]="lomake.kuukaudenLahetysTyyppi">
              <mat-radio-button value="pvm">{{ 'toistuvat.dialog.paivamaara' | translate | async }}</mat-radio-button>
              <mat-radio-button value="paiva">{{ 'toistuvat.dialog.paiva' | translate | async }}</mat-radio-button>
            </mat-radio-group>
            @if (lomake.kuukaudenLahetysTyyppi().value() === 'pvm') {
              <mat-form-field>
                <mat-label>{{ 'toistuvat.dialog.paiva' | translate | async }}</mat-label>
                <mat-select [formField]="lomake.kuukaudenPaiva">
                  @for (paiva of kuukaudenPaivat; track paiva) {
                    <mat-option [value]="paiva"> {{ paiva }}. </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (lomake.kuukaudenLahetysTyyppi().value() === 'paiva') {
              <div class="flex-rivi">
                <mat-form-field>
                  <mat-label>{{ 'toistuvat.dialog.jarjestysnumero' | translate | async }}</mat-label>
                  <mat-select [formField]="lomake.kuukaudenJarjestysnumero">
                    @for (jarj of jarjestysnumerot; track jarj) {
                      <mat-option [value]="jarj.arvo">
                        {{ jarj.nimi }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{ 'toistuvat.dialog.viikonpaiva' | translate | async }}</mat-label>
                  <mat-select [formField]="lomake.kuukaudenViikonpaiva">
                    @for (paiva of viikonpaivat; track paiva) {
                      <mat-option [value]="paiva.arvo">
                        {{ paiva.nimi }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (naytaKuukaudenPaivaVaroitus) {
              <div class="warning-text">
                {{ 'toistuvat.dialog.kuukauden-paiva-varoitus' | translate | async }}
              </div>
            }
          </div>
        }
        @if (naytaVuodenValinta) {
          <div class="flex-rivi">
            <mat-form-field>
              <mat-label>{{ 'toistuvat.dialog.kuukausi' | translate | async }}</mat-label>
              <mat-select [formField]="lomake.vuosiKuukausi">
                @for (kk of kuukaudet; track kk) {
                  <mat-option [value]="kk.arvo">
                    {{ kk.nimi }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'toistuvat.dialog.paiva' | translate | async }}</mat-label>
              <mat-select [formField]="lomake.vuosiPaiva">
                @for (paiva of kuukaudenPaivat; track paiva) {
                  <mat-option [value]="paiva"> {{ paiva }}. </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (naytaPaattyminenValinta) {
          <mat-form-field>
            <mat-label>{{ 'toistuvat.dialog.paattyminen' | translate | async }}</mat-label>
            <mat-select [formField]="lomake.paattyminenTyyppi">
              @for (valinta of paattyminenValinnat; track valinta) {
                <mat-option [value]="valinta.arvo">
                  {{ valinta.nimi }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (lomake.paattyminenTyyppi().value() === 'pvm') {
          <mat-form-field>
            <mat-label>{{ 'toistuvat.dialog.paattymispvm' | translate | async }}</mat-label>
            <input matInput [matDatepicker]="paattymisPicker" [formField]="lomake.paattymispvm" [matDatepickerFilter]="paattymispvmFilter" />
            <mat-datepicker-toggle matSuffix [for]="paattymisPicker"></mat-datepicker-toggle>
            <mat-datepicker #paattymisPicker></mat-datepicker>
            <mat-error>{{ 'toistuvat.dialog.virhe.virheellinen-pvm' | translate | async }}</mat-error>
          </mat-form-field>
        }
        @if (lomake.paattyminenTyyppi().value() === 'maara') {
          <mat-form-field>
            <mat-label>{{ 'toistuvat.dialog.lahetysmaara' | translate | async }}</mat-label>
            <input matInput type="number" [formField]="lomake.lahetysmaara" />
            @if (onkoVirhe(lomake.lahetysmaara, 'required')) {
              <mat-error>{{ 'toistuvat.dialog.virhe.pakollinen-maara' | translate | async }}</mat-error>
            }
            @if (onkoVirhe(lomake.lahetysmaara, 'min')) {
              <mat-error>{{ 'toistuvat.dialog.virhe.maara-min' | translate | async }}</mat-error>
            }
            @if (onkoVirhe(lomake.lahetysmaara, 'max')) {
              <mat-error>{{ 'toistuvat.dialog.virhe.maara-max' | translate | async }}</mat-error>
            }
          </mat-form-field>
        }
        <div class="toiston-kuvaus">
          {{ toistonKuvaus }}
        </div>
        @if (validointiVirheet.length > 0) {
          <div class="validation-errors">
            @for (virhe of validointiVirheet; track virhe) {
              <div class="error-text">
                {{ virhe }}
              </div>
            }
          </div>
        }
      </form>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button class="secondarybutton" (click)="peruuta()">{{ 'toistuvat.dialog.peruuta' | translate | async }}</button>
    <button mat-button class="primarybutton" (click)="tallenna()">{{ 'toistuvat.dialog.tallenna' | translate | async }}</button>
  </mat-dialog-actions>
</div>
